import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AuthNoticeService } from '../../../core/auth';
import { ConfigDebtService} from '../../../core/e-commerce';
import { HttpClient } from '@angular/common/http';
import { ConfigBrochureService } from '../../../core/e-commerce/_services/config-brochure.service';
import { CampaignService } from '../../../core/services/campaign.service';

@Component({
  selector: 'kt-dialog-config-brochure',
  templateUrl: './dialog-config-brochure.component.html',
  styleUrls: ['./dialog-config-brochure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfigBrochureComponent implements OnInit {

    detailForm: FormGroup;
    error: boolean = false;
    isLoadingResults = false;
    items : string[] = ["Guapa","Folleto_Extra"]
    item : string;
    campaigns;

    constructor(
        private configBrochureService : ConfigBrochureService,
        private _snackBar: MatSnackBar,
        private http: HttpClient,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogConfigBrochureComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
        private campaignService: CampaignService,
    ) {
    }

    ngOnInit() {
        this.authNoticeService.setNotice(null);
        this.loadCampaigns();
        this.initForms();
    }

    loadCampaigns() {
        this.campaignService.getCampaigns().subscribe(res => {
            this.campaigns = res;
            if (res.length > 0 && this.data) {
                this.detailForm.patchValue({ campaignId: res.filter(x=>x.id == this.data.campaignId)[0].id });
            }
            this.cdr.detectChanges();
        });
    }

    initForms() {
        let model;
        if (this.data) {
            model = this.data;
            this.item = this.items[model.type]           
        } else {
            model = {};
        }    
        this.detailForm = this.fb.group({
            id: [model.id],
            campaignId: [null, Validators.required],
            type:  [this.items[model.type] , Validators.required],
            url: [model.url, Validators.required],           
        });
    }

    saveOrderEvent() {
        const controls = this.detailForm.controls;
        if (this.detailForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }
 
        if (this.data == null) {
            this.configBrochureService.createBrochureConfig(this.detailForm.value).subscribe(resp => {
                    this.dialogRef.close(true);
                    this.cdr.detectChanges();
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        } else {
            this.configBrochureService.editBrochureConfig(this.detailForm.value).subscribe(() => {
                    this.dialogRef.close(true);
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.detailForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }
}
